import React from "react";
import "../ProcedureForm.css";
import "../modern-theme.css";
import { Grid } from "@material-ui/core";
import { useSelector } from "react-redux";

export default function Header({ documento, position }) {
  const { _category, _nameSchema, participants } = documento;
  const gestores = useSelector(({ documento }) => documento?.gestores) || [];

  // Build step list from first participant's flow
  let steps = [];
  let currentStageIndex = 0;
  try {
    const firstParticipant = participants && participants[0];
    const gestor = gestores[0];
    if (firstParticipant) {
      // Walk the flow: previous chain + current next
      const visited = new Set();
      let node = firstParticipant;
      const forward = [];
      // next chain
      while (node && node.next && !visited.has(node.next.id)) {
        visited.add(node.next.id);
        forward.push({
          name: node.next.name || "Etapa",
          fn: node.next["custom:functions"],
        });
        // bpmnAnalyser doesn't chain forward by default; break after 1 step
        break;
      }
      // Collect from gestor history
      const history = (gestor && gestor.history) || {};
      const historyArr = Object.values(history)
        .filter((h) => h && h.titleStage && h.type !== "END")
        .map((h) => ({ name: h.titleStage, fn: h.type, done: true }));
      steps = [...historyArr];
      if (firstParticipant.next && firstParticipant.next.name) {
        steps.push({
          name: firstParticipant.next.name,
          fn: firstParticipant.next["custom:functions"],
          active: true,
        });
      }
      currentStageIndex = historyArr.length;
    }
  } catch (e) {
    steps = [];
  }

  return (
    <>
      <div
        className="headerFlow headerReview"
        style={{ flexGrow: 1, height: "380px", backgroundColor: "#1d0c8e" }}
      >
        <Grid
          className="titleFlow tileReview"
          style={{ height: "70%" }}
          container
          direction="row"
          justify={position ? "center" : "flex-start"}
          alignItems="center"
        >
          <Grid
            item
            style={
              position
                ? { textAlign: "center", width: "100%" }
                : { display: "flex", justifyContent: "center", width: "100%", margin: 10, flexDirection: "column", alignItems: "center" }
            }
          >
            {/* Sin categoría el h3 quedaba como una píldora vacía sobre el título */}
            {_category?.trim() && (
              <h3 style={{ color: "#fff", fontSize: "22px", fontWeight: "500", margin: 0 }}>
                {_category}
              </h3>
            )}
            <h1 style={{ color: "#fff", fontStyle: "italic", marginTop: "8px" }}>
              {_nameSchema}
            </h1>

            {steps.length > 0 && (
              <div className="gd-stepper" aria-label="Progreso del proceso">
                {steps.map((step, idx) => (
                  <React.Fragment key={idx}>
                    <div
                      className={
                        "gd-step " +
                        (step.done ? "done" : step.active ? "active" : "")
                      }
                      style={{ animationDelay: `${0.1 + idx * 0.08}s` }}
                    >
                      <span className="gd-step-number">
                        {step.done ? "✓" : idx + 1}
                      </span>
                      <span className="gd-step-label">{step.name}</span>
                    </div>
                    {idx < steps.length - 1 && (
                      <span className="gd-step-separator" />
                    )}
                  </React.Fragment>
                ))}
              </div>
            )}
          </Grid>
        </Grid>
      </div>
    </>
  );
}
